import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Moon as MoonIcon, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Starfield from "@/components/Starfield";
import Luna from "@/components/Luna";

const NAV = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/summarize", label: "AI Summary" },
  { to: "/subjects", label: "Subjects" },
  { to: "/progress", label: "Progress" },
];

export default function DashboardShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const doLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="relative min-h-screen bg-[#06080d] text-white">
      <div className="pointer-events-none fixed inset-0">
        <Starfield count={50} />
        <div className="absolute right-[-10%] top-[-10%] h-[420px] w-[420px] rounded-full"
             style={{ background: "radial-gradient(circle, rgba(255,255,255,0.05), transparent 70%)" }} />
      </div>

      <header className="glass-strong sticky top-0 z-40 border-b border-white/10">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5">
          <Link to="/dashboard" className="flex items-center gap-2.5" data-testid="shell-logo">
            <MoonIcon className="h-6 w-6 text-white" strokeWidth={1.5} />
            <span className="font-sans text-lg font-semibold tracking-tight">Quizer</span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`rounded-full px-4 py-1.5 text-sm transition-colors ${
                  pathname === n.to ? "bg-white/10 text-white" : "text-zinc-400 hover:text-white"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-zinc-300 sm:block" data-testid="shell-username">
              {user?.name}
            </span>
            <button
              onClick={doLogout}
              data-testid="logout-button"
              className="flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 text-sm text-zinc-300 transition-colors hover:border-white/25 hover:text-white"
            >
              <LogOut className="h-4 w-4" strokeWidth={1.5} /> Log out
            </button>
          </div>
        </div>
      </header>

      <main className="relative z-10 mx-auto max-w-7xl px-5 py-10">{children}</main>
      <Luna />
    </div>
  );
}
